//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'mg-dialog',
  props: {
    // 控制是否展示或隐藏对话框
    isShowDialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    showCloseIcon: {
      type: Boolean,
      default: true,
    },
    mask: {
      type: Boolean,
      default: true,
    },
    clickMaskClose: {
      type: Boolean,
      default: false,
      require: true,
    },
    lockScroll: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    isShowDialog(val) {
      const classList = document.documentElement.classList;
      if (val) {
        classList.add('lock');
      } else {
        classList.remove('lock');
      }
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit('close');
    },
    // 点击遮罩层关闭弹框
    clickMaskCloseFn() {
      if (this.clickMaskClose) {
        this.$emit('close');
      }
    },
  },
};
